import React from 'react';
import moment from 'moment';
import TruncatedText from '../../../../components/common/TruncatedText';
import {useDispatch} from 'react-redux';
import {setSuppressDateIndicator} from '../../../../redux/slices/timeline';

interface CurrentDateFlagProps {
  position: { left?: string; right?: string; top: string };
}

export const CurrentDateFlag: React.FC<CurrentDateFlagProps> = ({
  position
}) => {
  const dispatch = useDispatch();
  const currentDate = moment().format('ddd, MMM DD, YYYY');

  return (
    <div
      id="current-date-flag"
      className="absolute !cursor-default"
      style={{
        width: 1,
        left: position.left,
        height: "100%",
        backgroundColor: '#22c55e',
      }}
      onMouseEnter={() => dispatch(setSuppressDateIndicator(true))}
      onMouseLeave={() => dispatch(setSuppressDateIndicator(false))}
    >
      <div
        className="sticky z-[1]"
        style={{
          top: position?.top,
        }}
      >
        <TruncatedText
          text="Today"
          tooltipTitle={`Today (${currentDate})`}
          className="text-xs bg-green-50 dark:bg-[#1b2333] text-black/80 dark:text-white/80 border border-green-500 dark:border-green-400 whitespace-nowrap overflow-hidden text-ellipsis px-2 py-0.5 rounded-r"
          placement="bottom-start"
          as="span"
        />
      </div>
    </div>
  );
}; 